export default __webpack_public_path__ + "static/media/logo1.ee44e354.svg";